var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWalletIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    fill: "#00CCCD",
    fillOpacity: 0.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3413_31330)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.3333 21.3333H42.6666V34.6667H41.3333V38.6667C41.3333 39.0203 41.1928 39.3594 40.9428 39.6095C40.6927 39.8595 40.3536 40 40 40H16C15.6463 40 15.3072 39.8595 15.0572 39.6095C14.8071 39.3594 14.6666 39.0203 14.6666 38.6667V17.3333C14.6666 16.9797 14.8071 16.6406 15.0572 16.3905C15.3072 16.1405 15.6463 16 16 16H40C40.3536 16 40.6927 16.1405 40.9428 16.3905C41.1928 16.6406 41.3333 16.9797 41.3333 17.3333V21.3333ZM38.6666 34.6667H30.6666C28.8985 34.6667 27.2028 33.9643 25.9526 32.714C24.7023 31.4638 24 29.7681 24 28C24 26.2319 24.7023 24.5362 25.9526 23.286C27.2028 22.0357 28.8985 21.3333 30.6666 21.3333H38.6666V18.6667H17.3333V37.3333H38.6666V34.6667ZM40 32V24H30.6666C29.6058 24 28.5883 24.4214 27.8382 25.1716C27.0881 25.9217 26.6666 26.9391 26.6666 28C26.6666 29.0609 27.0881 30.0783 27.8382 30.8284C28.5883 31.5786 29.6058 32 30.6666 32H40ZM30.6666 26.6667H34.6666V29.3333H30.6666V26.6667Z",
    fill: "#00CCCD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3413_31330"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletIcon);
export default __webpack_public_path__ + "static/media/walletIcon.db84b2419b4c1ed8c300e1ce208c1d96.svg";
export { ForwardRef as ReactComponent };